// newspaperConfig.js

export const weatherForecasts = [
    "Fair skies expected for planning committee meeting tomorrow.",
    "Scattered showers may delay construction projects this week.",
    "Sunny outlook for new development proposals.",
    "Gusty conditions ahead for roofing applications.",
    "Mild weather expected to increase outdoor planning works.",
    "Fog advisory: Planning committee to postpone site visits."
  ];
  
  export const historicalFacts = [
    "1887: The Edinburgh Planning Council rejected a proposal for a 'horseless carriage' parking facility as 'unnecessary and imprudent'.",
    "1923: The controversial 'steel-framed' construction method was first approved in the district despite significant opposition.",
    "1904: A record 347 planning applications were processed in a single day due to post-war reconstruction efforts.",
    "1932: The 'minimum window size' regulation was introduced following public health concerns about proper ventilation.",
    "1955: The first 'housing estate' proposal was approved, marking a shift from individual to group applications.",
    "1912: The planning board rejected an application for electric street lighting, citing 'unnecessary modernization'."
  ];
  
  export const editorsNotes = [
    "One cannot help but wonder if the applicant has considered the aesthetic implications of their design choices.",
    "This correspondent believes the council would do well to approve this sensible proposal with due haste.",
    "The dimensions specified appear modest, although one questions the necessity of such alterations.",
    "It is refreshing to see traditional materials specified in an age of questionable modern alternatives.",
    "The council's delay in processing similar applications last quarter was most unbecoming of public servants.",
    "This publication maintains that the preservation of architectural heritage remains paramount in such cases."
  ];
  
  export const classifieds = [
    {
      title: "DRAUGHTSMAN AVAILABLE",
      content: "Experienced architectural draughtsman seeks work. Specializing in planning application drawings. Reasonable rates. Telephone: Wilson 3467."
    },
    {
      title: "PLANNING CONSULTANT",
      content: "Former council official offers guidance on successful applications. 15 years experience. Guaranteed results or no fee. Write to Box 72 for appointment."
    },
    {
      title: "MODEL MAKERS",
      content: "Architectural models crafted for planning submissions. Exquisite detail. Fast turnaround. Fleming & Sons, 23 Castle Street."
    },
    {
      title: "TITLE DEED RESEARCH",
      content: "Complete property history and boundary investigations. Essential for development applications. Contact Hargreaves & Co., Solicitors."
    }
  ];
  
  export const vintageAdverts = [
    {
      title: "WILSON'S ARCHITECTURAL SUPPLIES",
      content: "Finest drafting tools for the modern architect. Reliable instruments for precise planning work. Visit our showroom at 42 Market Street.",
      tagline: "Quality Since 1887"
    },
    {
      title: "HARRINGTON WINDOWS & DOORS",
      content: "Elegant designs, superior craftsmanship. Beautify your home with our latest catalogue of styles. Telephone 576 for consultation.",
      tagline: "Distinguished Homes Choose Harrington"
    },
    {
      title: "PETERSON'S BUILDING MATERIALS",
      content: "Bricks, lumber, cement and all building necessities. Competitive rates for contractors. Delivery within city limits at no extra charge.",
      tagline: "Building the City, One Brick at a Time"
    }
  ];
  
  export const filterOptions = [
    { id: "all", label: "All Applications", icon: "🏢" },
    { id: "awaiting-decision", label: "Awaiting Decision", icon: "⏳" },
    { id: "awaiting-assessment", label: "Awaiting Assessment", icon: "📋" },
    { id: "recent", label: "Recent (Last 7 Days)", icon: "🔥" },
  ];